import { AuthActionTypes } from './action.type';

export const AuthActions = {
    async [AuthActionTypes.SetUserInfo]({commit}, data) {
        commit(AuthActionTypes.SetUserInfo, data);
    },

    async [AuthActionTypes.LogOut]({commit}) {
        commit(AuthActionTypes.LogOut);
    },

    async [AuthActionTypes.SetCustomerInfo]({commit}, data) {
        commit(AuthActionTypes.SetCustomerInfo, data);
    },
};
